import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import styles from './ProressionalCourse.module.css'

const useStyles = makeStyles({
  root: {
  },
  headerCertificateBtn: {
    backgroundColor: '#ffffff',
    width: '250px',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    margin: '0 auto',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      fontSize: '14px',
      width: '200px !important',
    },

  },

})

function ProfessionalCourseHeader() {
  const classes = useStyles()

  return (
    <div className={styles.headerMain}>
      <div className={styles.headerDesc}>
        شما میتوانید 3 مجموعه آموزشی را انتخاب نمایید.
        <br />
        برای انتخاب بیشتر به ازای هر مجموعه آموزشی مبلغ 390 هزار تومان پرداخت نمایید
      </div>
      <div className={styles.headerCertificate}>
        <div className={styles.headerCertificateText}>
          شما هزینه گواهینامه را پرداخت کرده اید
        </div>
        <Button className={classes.headerCertificateBtn}>
          درخواست گواهینامه
        </Button>
      </div>
    </div>
  )
}

export default ProfessionalCourseHeader
